const noData = [null, '', undefined, 'null']
import moment from "moment"

const state = {};

const getters = {
  timeFormat (state, getters, rootState) {
    if(
      !noData.includes(rootState.auth.user) &&
      !noData.includes(rootState.auth.user_settings) &&
      rootState.auth.user_settings.some(i => i.key === 'time_format')
    ) {
      return rootState.auth.user_settings.find(i => i.key === 'time_format').value
    }
    return 'HH:mm:ss'
  },
  dateFormat (state, getters, rootState) {
    if(
      !noData.includes(rootState.auth.user) &&
      !noData.includes(rootState.auth.user_settings) &&
      rootState.auth.user_settings.some(i => i.key === 'date_format')
    ) {
      return rootState.auth.user_settings.find(i => i.key === 'date_format').value
    }
    return 'YYYY[-]MM[-]DD'
  },
  displayTime: (state, getters) => (time) => {
    if (time) {
      return moment(time).format(getters.timeFormat)
    }
    return moment().format(getters.timeFormat)
  },
  displayDate: (state, getters) => (date) => {
    if (date) {
      return moment(date).format(getters.dateFormat)
    }
    return moment().format(getters.dateFormat)
  },
  displayDateAndTime: (state, getters) => (date) => {
    if (date) {
      return moment(date).format(`${getters.dateFormat} ${getters.timeFormat}`)
    }
    return moment().format(`${getters.dateFormat} ${getters.timeFormat}`)
  }
}

const actions = {}

const mutations = {};

export default {
  state,
  actions,
  mutations,
  getters
};